<template>
    <div class="main">
        <fade-transition :duration="{enter: 1000, leave: 10}" @after-enter="mediasShow = true" appear>
            <home-carousel @show="onShow"
                      @hide="onHide"
                      v-if="show"
                      data-delay="5000"
                      :sliding="true"
                      :slides="backgrounds"
            ></home-carousel>
        </fade-transition>

        <section v-if="show" class="sectionFeaturedWorks">
            <div class="containerWrapper">
                <div class="container">
                    <div class="content">
                        <media-list
                            v-if="mediasShow"
                            :medias="recentMedias"
                            :gridSize="5"
                            :listClass="'featuredVideoListContainer'"
                            :delay="0"
                            >
                        </media-list>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import {wait, preloadImg} from "../utils/shared";
    import {menusMixin} from "../mixins/menus";
    import {menusNames as mn,} from "../constants/menus";

    export default {
        mixins: [menusMixin],
        data() {
            return {
                show: false,
                mediasShow: false,
            }
        },
        computed: {
            ...mapGetters('home', {
                'backgrounds': 'backgrounds',
                'posterFallback': 'posterFallback',
            }),
            ...mapGetters('featured', {
                'recentMedias': 'recentMedias',
            }),
            ...mapGetters('ui', {
                'canAutoplay': 'canAutoplay',
            }),
            ...mapState({
                editor: state => state.home.editor,
            }),
        },
        mounted() {
            //debugger
            this.preloadBackgrounds()
            this.setSeo(this.$_getMenuSeo(mn.HOME))
        },
        watch: {},
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            async preloadBackgrounds() {
                let self = this

                //await wait(2000)

                if (this.canAutoplay) {
                    this.backgrounds.map((slide) => {
                        this.$store.commit('home/setLoadedBackground', slide)
                    })
                } else {
                    let all = this.backgrounds.map((slide) => {
                        let poster = self.posterFallback(slide)
                        let promise = Promise.resolve()

                        if (!slide._loaded && poster) {
                            promise = preloadImg(poster)
                                .then(() => {
                                    this.$store.commit('home/setLoadedBackground', slide)
                                }).catch(() => {})

                        }

                        return promise
                    })

                    await Promise.all(all)
                        .then(() => {
                            //console.log('backgrounds preloaded')
                        })
                }

                this.show = true
            },
            onShow() {
                this.show = true
            },
            onHide() {
                this.show = false
            },
        }
    }
</script>
